import { useTheme } from '@mui/material/styles'
import { findKey } from 'lodash'
import * as React from 'react'

type FieldWrapperProps = {
  className?: string
  children: React.ReactNode
  error?: any
}

export type FieldWrapperPassThroughProps = Omit<FieldWrapperProps, 'className'>

export const FieldWrapper = (props: FieldWrapperProps) => {
  const theme = useTheme()
  const { className, error, children } = props

  const errorKey: string = findKey(error, 'message') || ''
  const errorMessage = error?.message || error?.[errorKey]?.message

  return (
    <div>
      <div>{children}</div>
      {errorMessage && (
        <div
          role="alert"
          aria-label={errorMessage}
          className={className}
          style={{
            marginTop: 4,
            marginBottom: 0,
            marginRight: 14,
            marginLeft: 14,
            fontSize: '0.75rem',
            color: theme.palette.error.main
          }}
        >
          {errorMessage}
        </div>
      )}
    </div>
  )
}
